define('home/models/SettingsModeration',[
    'core/config',

    'home/models/common/BaseSettings',
    'core/UniqueModel',
], function (
    config,

    BaseSettings,
    UniqueModel
) {
    'use strict';

    var SettingsModeration = BaseSettings.extend({
        url: config.urls.apiSettings + 'moderation/',

        toJSON: function () {
            return {
                'disable_approved': this.get('disable_approved'),
                'receive_unapproved': this.get('receive_unapproved'),
                'receive_spam': this.get('receive_spam'),
                'forum_subscriptions': this.get('forum_subscriptions'),
            };
        },
    });

    UniqueModel.addType('SettingsModeration', SettingsModeration);

    return SettingsModeration;
});


